exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-input-container{width:100%;}\n.red_shape.small_size{height: auto;}\nh2{font-size: 22px; line-height: 27px;}\n.mat-select{margin-top: 12px;white-space: nowrap;}\n.outer_width{width:900px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/attendee-form/attendee-form.component.css
// module id = ../../../../../src/app/supplier/profile/attendee-form/attendee-form.component.css
// module chunks = 39